module.exports = __webpack_public_path__ + "img/0-105.eb0eb092.jpg";